module.exports = __webpack_public_path__ + "img/wmcxyl.15c85b12.png";